document.addEventListener("click", function (event) {
  const menus = document.querySelectorAll(".mega-menu");

  menus.forEach(function(menu) {
    if (!menu.contains(event.target)) {
      menu.removeAttribute("open");
    }
  });
});


document.addEventListener("DOMContentLoaded", function(){

  const popup = document.getElementById("applyPopup");
  const closeBtn = document.querySelector(".popup-close");

  document.querySelectorAll(".apply-btn").forEach(btn => {

    btn.addEventListener("click", function(){

      popup.style.display="flex";

      document.getElementById("jobTitleField").value = this.dataset.job;
      document.getElementById("jobCountryField").value = this.dataset.country;

      document.getElementById("popupJobTitle").innerText = this.dataset.job;
      document.getElementById("popupJobExp").innerText = this.dataset.exp;
      document.getElementById("popupJobDesc").innerText = this.dataset.desc;

    });

  });

  closeBtn.addEventListener("click", function(){
    popup.style.display="none";
  });

  popup.addEventListener("click", function(e){
    if(e.target === popup){
      popup.style.display="none";
    }
  });

});
